import { sendAxiosRequest } from '../../utils/sendRequest';
import { api } from '../../Api';
import UrlBuilder from '../../url/UrlBulder';
import IDataObjectParams from '../../../models/params/IDataObjectParams';
import IMerchProductOrderResponse from '../../../models/responces/IMerchProductOrderResponse';

export interface IApiDuplicateOrderParams {
  id: number;
  dataObjectParams?: IDataObjectParams;
}
const apiDuplicateOrder = (params: IApiDuplicateOrderParams) =>
  sendAxiosRequest({
    method: 'post',
    headers: { Authorization: api.getToken() },
    url: UrlBuilder.getURL({
      handler: 'order',
      action: 'duplicate',
      dataObjectParams: params.dataObjectParams || undefined
    }),
    data: { ID: params.id },
    responseType: 'json'
  }).then(resp => resp.data) as Promise<IMerchProductOrderResponse>;
export default apiDuplicateOrder;
